/**
 * 뷰포트에 헤당 element가 보이도록 세로 윈도우 스크롤을 이동시켜 준다.
 * @param element 뷰포트로 이동시킬 element
 * @param position 'top' | 'bottom' | 'middle' 뷰포트 어느 부분에 위치시킬지 결정
 * @param margin 'top'/'bottom' 인 경우에 위/아래에 딱 붙이지 않고 간격을 띄우기 위한 수치 (단위 : 픽셀)
 */
export function verticalWindowScrollIntoView({
  element,
  position,
  margin = 0,
}: {
  element: HTMLElement;
  position: 'top' | 'bottom' | 'middle';
  margin?: number;
}) {
  if (!element || typeof window === 'undefined') {
    return;
  }
  const rect = element.getBoundingClientRect();
  // element의 실제 스크롤 top 위치
  const elementScrollTop = window.pageYOffset + rect.top;
  if (position === 'top') {
    window.scrollTo(window.pageXOffset, elementScrollTop - margin);
  } else if (position === 'bottom') {
    window.scrollTo(
      window.pageXOffset,
      elementScrollTop - window.innerHeight + rect.height + margin
    );
  } else {
    window.scrollTo(
      window.pageXOffset,
      elementScrollTop - (window.innerHeight - rect.height) / 2
    );
  }
}
